import { render, staticRenderFns } from "./AvailablesPrivadas.vue?vue&type=template&id=38edf904&scoped=true"
import script from "./AvailablesPrivadas.vue?vue&type=script&lang=js"
export * from "./AvailablesPrivadas.vue?vue&type=script&lang=js"
import style0 from "./AvailablesPrivadas.vue?vue&type=style&index=0&id=38edf904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38edf904",
  null
  
)

export default component.exports